export const FontPurposes = [
  "Title" as const,
  "Subtitles" as const,
  "Text" as const,
];

export type FontPurpose = (typeof FontPurposes)[number];
